export const PACKAGE_VERSION = 'PS_PACKAGE_VERSION';
export const COMMIT_HASH = 'PS_COMMIT_HASH';
export const BUILD_DATE = 'PS_BUILD_DATE';
